import {
  CHANGE_FEATURE_FLAGS_SUCCESS,
  CHANGE_FEATURE_FLAGS_ERROR,
} from 'constants/feature-flag-action-types';

import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

const changeFeatureFlagsSuccess = (flags) => ({
  type: CHANGE_FEATURE_FLAGS_SUCCESS,
  payload: flags,
});

function changeFeatureFlagsError(error) {
  const errorMessage = 'changeFeatureFlagsError\n\n' + error;
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: CHANGE_FEATURE_FLAGS_ERROR,
  };
}

export function changeFeatureFlags(flagArray) {
  return (dispatch) => {
    try {
      dispatch(changeFeatureFlagsSuccess(flagArray));
    } catch (error) {
      changeFeatureFlagsError(error);
    }
  };
}